module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7d2d70f6!./packages/dof-result/colmo.css
// module id = 526
// module chunks = 0 1